import { firebase } from '../firebase-config';
import { COLLECTIONS, BaseUrl, APP_ENV } from '../config';
import { getLoginToken } from '../storage';
import axios from 'axios';
import { collection, getDocs } from 'firebase/firestore';

/**
 * Get Issue detail by issue id
 * @param {*} id  : issueId
 * @param {*} onSuccess
 * @param {*} onError
 */
export async function getOneIssue(id, onSuccess, onError) {
  try {

    const token = getLoginToken();
    const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

    const axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        withCredentials: true,
        ...authHeaders,
      },
    };

    const body = { issueId: id };
    const requestUrl = `${BaseUrl}getIssueDetails`;

    console.log("[getOneIssue] fetch start", { env: APP_ENV, issueId: id, url: requestUrl });

    const response = await axios.post(
      requestUrl,
      body,
      axiosConfig
    );

    const payload = response?.data || {};
    console.log("[getOneIssue] fetch response", {
      issueId: id,
      status: payload.status,
      message: payload.message,
      publicAccessAllowed: payload.publicAccessAllowed,
      hasData: !!(payload.result || payload.data),
    });

    if (payload.publicAccessAllowed === false) {
      onSuccess &&
        onSuccess({
          status: true,
          publicAccessAllowed: false,
          message: payload.message,
        });
      return;
    }

    const issueData = payload.result || payload.data;
    if (payload.status && issueData) {
      onSuccess &&
        onSuccess({
          status: true,
          publicAccessAllowed: true,
          data: issueData,
        });
    } else {
      onError &&
        onError({
          status: false,
          error: payload.message || payload.result || "Unable to load issue",
        });
    }
  } catch (error) {
    const payload = error?.response?.data;
    console.log("[getOneIssue] fetch error", {
      issueId: id,
      status: error?.response?.status,
      message: payload?.message || error?.message,
      publicAccessAllowed: payload?.publicAccessAllowed,
    });
    if (payload?.publicAccessAllowed === false) {
      onSuccess &&
        onSuccess({
          status: false,
          publicAccessAllowed: false,
          message: payload.message,
        });
      return;
    }
    onError &&
      onError({
        status: false,
        error: payload?.message || error?.message || "Unable to load issue",
      });
  }
}

export async function getAllEmployee(onSuccess, onError) {
  try {
    const colRef = collection(firebase, COLLECTIONS.USERS);

    const querySnapshot = await getDocs(colRef);

    if (querySnapshot.empty) {
      onError && onError({ status: false, error: "No employees found" });
    } else {
      const employees = [];
      querySnapshot.forEach(doc => {
        employees.push({ id: doc.id, ...doc.data() });
      });
      onSuccess && onSuccess({ status: true, data: employees });
    }
  } catch (error) {
    onError && onError({ status: false, error });
  }
}
